import { render, staticRenderFns } from "./vue-scratchable.vue?vue&type=template&id=df1c6910&scoped=true&"
import script from "./vue-scratchable.vue?vue&type=script&lang=js&"
export * from "./vue-scratchable.vue?vue&type=script&lang=js&"
import style0 from "./vue-scratchable.vue?vue&type=style&index=0&id=df1c6910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1c6910",
  null
  
)

export default component.exports